import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item", "button"]

  showMore(event) {
    event.preventDefault()
    
    this.itemTargets.forEach(item => {
      item.classList.remove('hidden')
    })
    
    if (this.hasButtonTarget) {
      this.buttonTarget.classList.add('hidden')
    }
  }
}
